import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';

import React, { Component } from 'react';

import Date from 'client/components/date';
import MenuSection from 'client/components/menu-section';

import { PageStructureProps, ShareholdersData, SharesData } from 'client/bundles/types';
import './index.css';

const b = cn('structure');
const bPageTitle = cn('page-title');

class Structure extends Component<PageStructureProps> {
    static contextType = LangContext;

    renderSharesData = (shares: SharesData, dictionary: { [key: string]: string }) => {
        return (
            <div className={b('shares')}>
                <div className={b('total-text')}>{shares.totalLabel}</div>
                <div className={b('total')}>{shares.total}</div>

                <div className={b('including')}>
                    <div className={b('including-text')}>{dictionary.including}:</div>
                    {shares.including &&
                        <div className={b('shares-info')}>
                            <div className={b('shares-info-item')}>
                                <strong className={b('shares-number')}>{shares.including.classA}</strong> {dictionary.classA}
                            </div>
                            <div className={b('shares-info-item')}>
                                <strong className={b('shares-number')}>{shares.including.classB}</strong> {dictionary.classB}
                            </div>
                            <div className={b('shares-info-item')}>{dictionary.onePriorityShare}</div>
                        </div>
                    }
                </div>

                <div className={b('excluding')}>{shares.excluding}</div>
            </div>
        );
    }

    renderShareholdersData = (shareholders: ShareholdersData, dictionary: { [key: string]: string }) => {
        return (
            <div className={b('shareholders')}>
                <div className={b('shareholders-table')}>
                    <div className={b('shareholders-head')}>
                        <div className={b('shareholders-header')}>{dictionary.shareholders}</div>
                        <div className={b('shareholders-percent')}>{dictionary.economicOwnership},&nbsp;%</div>
                        <div className={b('shareholders-percent')}>{dictionary.votingPower},&nbsp;%</div>
                    </div>
                    <div className={b('shareholders-item')}>
                        <div className={b('shareholders-header')}><strong>{shareholders.preIPO.title}</strong></div>
                        <div className={b('shareholders-percent')}><strong>{shareholders.preIPO.eo}</strong></div>
                        <div className={b('shareholders-percent')}><strong>{shareholders.preIPO.vp}</strong></div>
                    </div>
                    <div className={b('shareholders-item')}>
                        <div className={b('shareholders-header', { details: true })}>
                            <div className={b('shareholders-header-details')}>{shareholders.volozh.title}</div>
                        </div>
                        <div className={b('shareholders-percent')}>{shareholders.volozh.eo}</div>
                        <div className={b('shareholders-percent')}>{shareholders.volozh.vp}</div>
                    </div>
                    <div className={b('shareholders-item')}>
                        <div className={b('shareholders-header', { details: true })}>
                            <div className={b('shareholders-header-details')}>{shareholders.otherDirectors.title}</div>
                        </div>
                        <div className={b('shareholders-percent')}>{shareholders.otherDirectors.eo}</div>
                        <div className={b('shareholders-percent')}>{shareholders.otherDirectors.vp}</div>
                    </div>
                    <div className={b('shareholders-item')}>
                        <div className={b('shareholders-header')}><strong>{shareholders.otherPreIPO.title}</strong></div>
                        <div className={b('shareholders-percent')}><strong>{shareholders.otherPreIPO.eo}</strong></div>
                        <div className={b('shareholders-percent')}><strong>{shareholders.otherPreIPO.vp}</strong></div>
                    </div>
                    <div className={b('shareholders-item', { total: true })}>
                        <div className={b('shareholders-header')}><strong>{shareholders.publicInvestors.title}</strong></div>
                        <div className={b('shareholders-percent')}><strong>{shareholders.publicInvestors.eo}</strong></div>
                        <div className={b('shareholders-percent')}><strong>{shareholders.publicInvestors.vp}</strong></div>
                    </div>
                    <div className={b('shareholders-item')}>
                        <div className={b('shareholders-header')}><strong>{shareholders.total.title}</strong></div>
                        <div className={b('shareholders-percent')}><strong>{shareholders.total.eo}</strong></div>
                        <div className={b('shareholders-percent')}><strong>{shareholders.total.vp}</strong></div>
                    </div>
                </div>

                {
                    shareholders.note &&
                    <div className={b('note')}>
                        {shareholders.note}
                    </div>
                }
            </div>
        );
    }

    render() {
        const { structure, title, pageName, sectionTitle } = this.props;
        const { lang } = this.context;
        const isLangRu = lang === 'ru';

        if (!structure) {
            return null;
        }

        return (
            <div className={b()}>
                <h1 className={bPageTitle(isLangRu ? { type: 'border' } : '')}>
                    {isLangRu ? title : sectionTitle}
                </h1>

                {

                    /* TODO разобраться с подменю IR-571 */
                    lang === 'en' && <MenuSection type="shareholders" pageName={pageName} />
                }

                <p className={b('date')}>
                    {structure.dictionary.dataAsOf}&nbsp;
                    <Date dateStart={structure.date} />
                </p>

                <div className={b('content')}>
                    {this.renderSharesData(structure.shares, structure.dictionary)}
                    {this.renderShareholdersData(structure.shareholders, structure.dictionary)}
                </div>
            </div>
        );
    }

}

export default Structure;
